module.exports = __webpack_public_path__ + "static/img/2.dd54a524.jpg";